export const BASIC_KEY_YLD = '育龄段'
export const BASIC_KEY_YQTZ = '孕妇的孕前体重'
export const BASIC_KEY_YFDQTZ = '孕妇现在的体重'
export const BASIC_KEY_MCYJRQ = '末次月经日期'
export const BASIC_KEY_YFCSRQ = '孕妇的出生日期'
export const BASIC_KEY_YFSG = '孕妇身高'
export const BASIC_KEY_BBXB = '宝宝性别'
export const BASIC_KEY_BBCSRQ = '宝宝出生日期'
export const BASIC_KEY_BBNL = '宝宝的年龄'
export const BASIC_KEY_YFNL = '孕妇的年龄'

// 1.单选控件 2.多选控件 3.输入框 4.日期控件
export const INPUT_TYPES = {
  SINGLE_OPTION: 1,
  MULTI_OPTIONS: 2,
  SINGLE_INPUT: 3,
  SINGLE_DATE_PICKER: 4,
  SHOW_TIP: -1
}

/**
 * @param titleKey
 */
export function getPreDefinedInputMetaAttrs (titleKey) {
  const out = mk()
  
  switch (titleKey) {
    case BASIC_KEY_YFDQTZ:
    case BASIC_KEY_YQTZ:
      out.placeholder = 'kg'
      out.type = 'number'
      break
    case BASIC_KEY_YFSG:
      out.placeholder = 'cm'
      out.type = 'number'
      break
    case BASIC_KEY_BBNL:
      out.placeholder = '月'
      break
    case BASIC_KEY_YFNL:
      out.placeholder = '岁'
      break
    case BASIC_KEY_YFCSRQ:
      const fullYear = (new Date()).getFullYear()
      out.minYear = fullYear - 48 // 不提倡 高龄产妇
      out.maxYear = fullYear - 16 // 不提倡 16岁 前怀孕
      break
    case BASIC_KEY_BBCSRQ:
      out.maxYear = (new Date()).getFullYear()
      break
    default:
  }
  
  return out
  
  /**
   * @param title
   * @param placeholder
   * @param type
   * @return {{placeholder: string, title: string, type: string}}
   */
  function mk (title = '请输入', placeholder = '', type = 'text') {
    return {
      title,
      placeholder,
      type
    }
  }
}
